import React from "react";
import { FooterBrand } from "./footer-brand";
import { FooterRes, FooterResSocial } from "../../../typescript/response";
import Image from "next/image";
import { Footer as OldFooter } from "../footer-old";

import global from "./footer.module.scss";

const Footer = ({
  data
}: FooterProps) => {
  // console.log('foobar', data?.taxonomies);
  const brand = data?.taxonomies?.[0]?.taxonomy_uid === 'brand' ? data?.taxonomies?.[0]?.term_uid : "brand";
  // console.log(data);
  const layout = data?.footer_layout && data?.footer_layout !== 'default' ? data?.footer_layout : null;
  
  return (
    !layout ? (
      <OldFooter
        footer={data}
        navMenu={data.navigation_menu}
      />
    ) : (
      <footer className={global.footer} data-brand={brand}>
        <div className={global.container}>
          <div className={global.grid}>
            <BrandSection
              logo={data.logo.url}
              logoAlt={data.logo.description}
              brandCopy={data.brand_copy}
              social={data.social}
            />
          </div>
        </div>
      </footer>
    )
  )
}

const BrandSection = ({
  logo,
  logoAlt,
  brandCopy,
  social
}: {
  logo: string,
  logoAlt: string,
  brandCopy?: string,
  social?: FooterResSocial
}) => {

  return (
    <div className={global.brandSection}>
      <div className={global.brandSectionLogo}>
        <img src={logo} alt={logoAlt} />
      </div>
      {brandCopy && (
        <div className={global.brandSectionCopy} dangerouslySetInnerHTML={{__html: brandCopy}} />
      )}
      {social && social?.length > 0 && (
        <div className={global.brandSectionSocial}>
          {social.map(item => (
            <a
              {...(item.link.$?.href as {})}
              href={item.link.href}
              title={item.link.title}
              key={item.link.title}
              className={global.socialIconLink}
            >
              <Image
                {...(item.image.$?.url as {})}
                src={`${item.image.url}?width=194&height=56&auto=webp&fit=crop,smart`}
                alt={item.image.description || item.link.title}
                width={194}
                height={56}
                loading="lazy"
                className={global.socialIcon}
              />
            </a>
          ))}
        </div>
      )}
    </div>
  )
}

interface FooterProps {
  data: FooterRes
}

export default Footer;